import React, { useState } from 'react';
import { Card, Form, Input, Button, Row, Col, message } from 'antd';
import { useHistory } from 'react-router-dom';
import registerService from '../../../../services/registerService';

const text = {
  title: '注册',
  username: '用户名',
  realName: '姓名',
  password: '密码',
  email: '邮箱',
  phone: '电话',
  address: '地址',
  abn: 'ABN',
  submit: '注册',
  back: '返回登录',
  success: '注册成功，请登录',
  duplicate: '用户名已被占用',
  failed: '注册失败，请检查填写内容',
};

const Register = () => {
  return (
    <div>
      <Row>
        <Col span={8}></Col>
        <Col span={8}>
          <RegComponent />
        </Col>
        <Col span={8}></Col>
      </Row>
    </div>
  );
};

const RegComponent = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleRegister = async (values) => {
    setLoading(true);
    try {
      await registerService.registerReq(values);
      message.success(text.success);
      history.push('/');
    } catch (err) {
      const msg =
        err.response && err.response.status === 409
          ? text.duplicate
          : text.failed;
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title={text.title} style={{ marginTop: 10 }}>
      <Form style={{ width: 300 }} layout='vertical' onFinish={handleRegister}>
        <Form.Item
          label={text.username}
          name='name'
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input placeholder='请输入用户名' />
        </Form.Item>
        <Form.Item
          label={text.realName}
          name='cnname'
          rules={[{ required: true, message: '请输入姓名' }]}
        >
          <Input placeholder='请输入姓名' />
        </Form.Item>
        <Form.Item
          label={text.password}
          name='password'
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password placeholder='请输入密码' />
        </Form.Item>
        <Form.Item label={text.email} name='email'>
          <Input placeholder='请输入邮箱' />
        </Form.Item>
        <Form.Item label={text.phone} name='phone'>
          <Input placeholder='请输入电话' />
        </Form.Item>
        <Form.Item label={text.address} name='address'>
          <Input placeholder='请输入地址' />
        </Form.Item>
        <Form.Item label={text.abn} name='abn'>
          <Input placeholder='请输入 ABN' />
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' loading={loading}>
            {text.submit}
          </Button>
          <a href='/' style={{ marginLeft: 50 }}>
            {text.back}
          </a>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Register;
